import React from 'react';
import PropTypes from 'prop-types';
import RichText from '../../rich-text/base';

// Utils
import { propLink } from '../../link-handler';
import { RichTextPropTypes } from '../../../prop-types';
import { replaceLineBreakShortCode } from '../../../utils/replace-shortcode-br';
import { consistentString } from '../../../utils/content-formatting';

// Components
import VideoEmbed from '../../video';

// Styles
import {
  StyledContainer,
  Title,
  Wrapper,
  BannerContent,
  MediaContainer,
  VideoContainer,
  MobileContent,
  DesktopContent,
  StyledCTA,
} from './styles';

const MadeInSocialHousingVideoHero = ({ content }) => {
  const { title, contentBlockOne, videoOne, ctaOne } = content;

  return (
    <Wrapper>
      <StyledContainer>
        <BannerContent>
          <Title>{replaceLineBreakShortCode(title)}</Title>
          {contentBlockOne ? <RichText richText={contentBlockOne} /> : null}
          {ctaOne ? (
            <DesktopContent>
              <StyledCTA
                bg={consistentString(ctaOne.ctaColor)}
                link={ctaOne.link}
              >
                {ctaOne.buttonText}
              </StyledCTA>
            </DesktopContent>
          ) : null}
        </BannerContent>
        {videoOne ? (
          <MediaContainer>
            <VideoContainer>
              <VideoEmbed {...videoOne} />
            </VideoContainer>
          </MediaContainer>
        ) : null}
        {ctaOne ? (
          <MobileContent>
            <BannerContent>
              <StyledCTA
                bg={consistentString(ctaOne.ctaColor)}
                link={ctaOne.link}
              >
                {ctaOne.buttonText}
              </StyledCTA>
            </BannerContent>
          </MobileContent>
        ) : null}
      </StyledContainer>
    </Wrapper>
  );
};

MadeInSocialHousingVideoHero.propTypes = {
  content: PropTypes.shape({
    title: PropTypes.string.isRequired,
    contentBlockOne: RichTextPropTypes,
    videoOne: PropTypes.object,
    ctaOne: PropTypes.shape({
      ctaColor: PropTypes.string.isRequired,
      buttonText: PropTypes.string.isRequired,
      link: propLink.isRequired,
    }),
  }),
};

export default MadeInSocialHousingVideoHero;
